module.exports = __webpack_public_path__ + "media/images/massage/cover-mobile-f946f59b9e98384795b5a3cc253ab599.jpg";